// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oOyWr","rootMobile":"styles_rootMobile__iUZ09"};